import { render, staticRenderFns } from "./_base-sync-modal.vue?vue&type=template&id=b3640ba6&scoped=true"
import script from "./_base-sync-modal.vue?vue&type=script&lang=js"
export * from "./_base-sync-modal.vue?vue&type=script&lang=js"
import style0 from "./_base-sync-modal.vue?vue&type=style&index=0&id=b3640ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3640ba6",
  null
  
)

export default component.exports